import { render } from "./InstallmentAgendaView.vue?vue&type=template&id=0ffaa7bf"
import script from "./InstallmentAgendaView.vue?vue&type=script&lang=js"
export * from "./InstallmentAgendaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__